import React, { useState } from "react";
import "../styles/contact.css";

// To enable Formspree: create a form at https://formspree.io and set
// REACT_APP_FORMSPREE_ENDPOINT in your .env (example: REACT_APP_FORMSPREE_ENDPOINT=https://formspree.io/f/your_id)
const FORMSPREE_ENDPOINT = process.env.REACT_APP_FORMSPREE_ENDPOINT || "https://formspree.io/f/your_form_id_here";

export default function Contact() {
  const [status, setStatus] = useState(null); // null | "sending" | "success" | "error"

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("sending");
    const form = e.target;
    const formData = new FormData(form);

    try {
      const res = await fetch(FORMSPREE_ENDPOINT, {
        method: "POST",
        body: formData,
        headers: { Accept: "application/json" },
      });

      if (res.ok) {
        setStatus("success");
        form.reset();
      } else {
        setStatus("error");
        console.error("Formspree returned status", res.status);
      }
    } catch (err) {
      setStatus("error");
      console.error(err);
    }
  };

  return ( 
    <section id="contact" className="contact-section">
      <div className="contact-container">
        
        {/* LEFT SIDE */}
        <div className="contact-left">
          <h2>Contact Us</h2>
          <p className="contact-desc">
            HomoDial Healthcare Solution Pvt. Ltd. is a trusted healthcare company
            providing comprehensive home-based medical care and homeopathic treatment.
            We specialize in serving senior citizens, elderly patients, and individuals suffering from chronic illnesses.
            Our team of qualified doctors, trained nurses, and skilled medical support staff delivers personalized care directly at the patient’s home, ensuring safe, comfortable, and stress-free treatment experiences.
          </p>

          <div className="contact-info">
            <p><span>Email:</span> 
              <a href="mailto:homodial01@gmail.com"> homodial01@gmail.com</a>
            </p>

            <p><span>Call:</span> 7253815103</p>
            <p><span>Call:</span> 9599201887</p>
          </div>
        </div>

        {/* RIGHT SIDE */}
        <div className="contact-right">
          <h3>Send Us a Message</h3>

          <form onSubmit={handleSubmit} noValidate>
            <input name="name" type="text" placeholder="Your Name" required />
            <input name="email" type="email" placeholder="Your Email" required />
            <textarea name="message" placeholder="Your Message" rows="4" required></textarea>

            <button type="submit" disabled={status === "sending"}>
              {status === "sending" ? "Sending..." : "Send Message"}
            </button>

            {status === "success" && (
              <div className="form-message success">Thanks! Your message has been sent. We'll contact you soon.</div>
            )}

            {status === "error" && (
              <div className="form-message error">Sorry, something went wrong. Please try again later.</div>
            )}
          </form>
        </div> 
      </div>

      {/* CALL FLOAT BUTTON */}
<a
  href="tel:+917253815103,+919599201887"
  className="call-float"
>
  <span className="call-icon">📞</span>
  <span className="call-text">Get in Touch</span>
</a>

            {/* SOCIAL MEDIA LINKS */}
<div className="social-links">
  <a
    href="https://www.facebook.com/share/1GfvnLwYas/"
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Facebook"
  >
    <img
      src="https://cdn.jsdelivr.net/gh/simple-icons/simple-icons/icons/facebook.svg"
      alt="Facebook"
    />
  </a>

  <a
    href="https://www.instagram.com/homodial.care01?utm_source=qr&igsh=azFkc3hpOTBvYjk2"
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Instagram"
  >
    <img
      src="https://cdn.jsdelivr.net/gh/simple-icons/simple-icons/icons/instagram.svg"
      alt="Instagram"
    />
  </a>
</div>


      {/* FOOTER TEXT */}
      <div className="contact-footer">
        <p>© 2026 All Rights Reserved | HomoDial Healthcare</p>
      </div>
    </section>
  );
}
